import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer-container">
      <div className="footer-sub-container">
        <div className="footer-text-wrap">
          <img src="/logo-white.png" alt="It's a Simcha" className="footer-logo" />
          <span>© {year} It's a Simcha. All rights reserved.</span>
        </div>
        <div className="footer-text-wrap">
          <strong style={{ color: '#fff' }}>Contact</strong>
          <a href="mailto:system@itsasimcha.net">system@itsasimcha.net</a>
          <Link to="/contact-us">Send a message</Link>
        </div>
        <div className="footer-text-wrap">
          <strong style={{ color: '#fff' }}>Links</strong>
          <Link to="/">Home</Link>
          <Link to="/contact-us">Contact Us</Link>
          <Link to="/terms-conditions">Terms & Conditions</Link>
        </div>
      </div>
    </footer>
  );
}
